import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m22.151 2.85-1.259 3.439 2.121 2.122a.735.735 0 0 1-.541 1.273l-3.653-.029-1.319 3.363a.785.785 0 0 1-1.485-.1L14.932 9.07 11.08 7.991a.786.786 0 0 1-.1-1.486l3.363-1.323-.029-3.653a.734.734 0 0 1 1.274-.543l2.122 2.121 3.441-1.257a.8.8 0 0 1 1 1m-7.219 6.22L.75 23.25"
    }, null, -1)
  ]));
}
const interfaceEditMagicWand = { render };
export {
  interfaceEditMagicWand as default,
  render
};
//# sourceMappingURL=interface-edit-magic-wand.svg.js.map
